export const MAX_TIMEOUT = 2147483647 // Maximum timeout value in milliseconds
